import React from 'react'
import PageContainer from '../PageContainer/PageContainer'
import classnames from 'classnames'
import styles from './Confirmation.module.scss'
import Analytics from 'analytics'

const Confirmation = (props) => {
  const primaryButtonClasses = classnames(
    'button',
    'button--primary',
    styles.closeButton
  )

  const description = `
    Thanks for helping us with your account details. The next step is for your
    Financial Advisor to contact you directly with the documents
    for your final review and signature.
  `

  const handleOnClose = () => {
    Analytics.track('User clicks Close Confirmation Page')
  }

  return (
    <div className={styles.Confirmation}>
      <PageContainer
        name="Nice Work!"
        description={[description]}>
        <a
          href="https://www.ellevest.com/private-wealth-management/how-were-different"
          onClick={handleOnClose}
          data-test-id="confirmation__close__cta"
          className={primaryButtonClasses}>
          Go to Ellevest.com
        </a>
      </PageContainer>
    </div>
  )
}

export default Confirmation



// WEBPACK FOOTER //
// ./src/components/Onboarding/Confirmation/Confirmation.jsx